import PaginationRequest from '@/common/pagination/entities/pagination-request'
import { EvaluationStatus } from '@/evaluations/entities/evaluation-status'

export default class EvaluationFilter {
  public search: string = ''
  public sortByFinishedAt = false
  public states: EvaluationStatus[] = []
  public paging: PaginationRequest = new PaginationRequest()
}
